import { create } from 'zustand';

type ProductId = {
    productId: string;
    setProductId: (newId: string) => void;
    resetProductId: () => void;
};

export const useProductIdStore = create<ProductId>()((set, get) => ({
    productId: '',
    setProductId: (newId: string) => {
        // Guard against setting the same productId
        if (get().productId === newId) return;

        set({ productId: newId });
    },
    resetProductId: () => set({ productId: '' }),
}));
